/* 获得数据 */
export const getComfirmNewsData = async (curPage, pageSize) => {

  try {
    const res = await fetch(`/${process.env.REACT_APP_API_CONTEXT}/service/notices/v1?curPag=${curPage}&pageSize=${pageSize}`, {
      method: "get"
    })
    return res;
  } catch {
    return null
  }
};
